<!-- <app-top-bar [authorSet]="user" [authorDetached]="true" *ngIf="!this.showTopBar"></app-top-bar> -->
<app-guest-sidebar *ngIf="displayTopbarGuest"></app-guest-sidebar>
<div [ngClass]="{ 'main': displayTopbarGuest }" id="slider-panel-features">
  <app-promo-stacks-top-bar *ngIf="displayPromoStacksModalForFeatures" [user]="user"></app-promo-stacks-top-bar>
  <div id="features" 
    class="mobile-optimization"
    [ngStyle]="{'margin-top': this.showTopBar ? '-20px' : '50px'}" >
    <!-- Standard Purchase  -->
    <div class="container" *ngIf="!isCheckout">
      <div class="progress" *ngIf="variant === 'control'">
        <div class="progress-item" *ngFor="let step of purchaseProcessService.steps">
          <div *ngIf="isInactiveCurrentStep(step)" class="step" [ngClass]="currentStepClass(step)">{{step.step}}</div>
          <a [routerLink]="step.path" [queryParams]="step.queryParams" *ngIf="isActiveStep(step)">
            <div class="step active">{{step.step}}</div>
          </a>
          <div class="label" *ngIf="isInactiveCurrentStep(step)">{{step.label}}</div>
          <a [routerLink]="step.path" [queryParams]="step.queryParams" *ngIf="isActiveStep(step)">
            <div class="label" [ngStyle]="{'color': isActiveStep(step) ? '#008af4' : 'rgba(0, 0, 0, .6)'}">
              {{step.active ? step.activeLabel : step.label}}
            </div>
          </a>
        </div>
      </div>
      <div *ngIf="variant === 'experimental'">
        <app-stepper></app-stepper>
      </div>
      <div [ngClass]="{ 'content': variant === 'control', 'large-container': variant === 'experimental' && currentStep > 1 }">
        <router-outlet></router-outlet>
      </div>
      <div class="footer-banner" *ngIf="currentStep === 2 && site.footerBannerImage">
        <a [href]="site.footerBannerLink" target="_blank"><img
            [src]="site.footerBannerImage" alt=""></a>
      </div>
    </div>
    <router-outlet *ngIf="isCheckout"></router-outlet>
  </div>
  <app-promo-stacks-modal
    modalId="stacks-modal"
    [user]="user"
    (closeModal)="displayPromoStacksModal = false"
    ></app-promo-stacks-modal>
</div>
